<template>
  <div>
    <Sidebar />
     <div v-if="getSelectedCompany.is_suspended">
      <Suspended />
    </div>
     <div v-else>
        <router-view></router-view>
    </div> 
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Swal from "sweetalert2";
export default {
  name: "app-layout",
  components: {
    Sidebar: () => import("@/components/Includes/Sidebar"),
    Suspended: () => import("@/components/Includes/ExpireCompanyView"),
  },
  computed: {
     ...mapGetters([
      "getSelectedCompany" ]),
  },
  mounted(){
   // this.hello();
  },
  methods: {
 hello(){
        Swal.fire({
        title: "Suspended Company",
        html: "Dear Customer Your account has been suspended. Your progress has not been lost. please contact with support team.",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "<a style='text-decoration: none; color: #13865a' target='_blank' href= 'https://gigstimer.com/contact-us/'>Contact Us</a>",
        showConfirmButton: false,
        reverseButtons: true,
      }).then((result) => {
      });
    }
  },
};
</script>

